import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSaleOrderModel } from "../saleOrderModel";
import { ISaleSoDetail } from "../saleOrderTypes";
import { useDictModel } from "../../../../base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

type statusType = {
    "sale-order.create": string,
    "sale-order.transfer": string,
    "sale-order.change": string,
    [key: string]: any
}
export function DataTable () {
    const { dataSource, selectedRowKeys, pgCfg, descRows, loadData, setSelectedRowKeys, setDescRows } = useSaleOrderModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const statusColor: statusType = {
        "sale-order.create": "blue",
        "sale-order.transfer": "green",
        "sale-order.change": "red",
    }

    const columns: ColumnsType<ISaleSoDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            // title: '销售订单号',
            title: Locale["Sales Order No."],
            width: 120,
            fixed: "left",
            dataIndex: 'saleOrderCode',
        }, {
            // title: '单据状态',
            title: Locale["Status"],
            width: 120,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string} />,
        }, {
            // title: '单据日期',
            title: Locale["Creation Time"],
            width: 150,
            dataIndex: 'createTime',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '客户名称',
            title: Locale["Customer"],
            width: 150,
            dataIndex: 'customerName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系人',
            title: Locale["Contact"],
            width: 150,
            dataIndex: 'contact',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系电话',
            title: Locale["Contact Number"],
            width: 150,
            dataIndex: 'phone',
        }, {
            // title: '销售金额',
            title: Locale["Sales Amount"],
            width: 150,
            dataIndex: 'totalAmount',
        }, {
            // title: '优惠金额',
            title: Locale["Discount Amount"],
            width: 150,
            dataIndex: 'discountTotalAmount',

        }, {
            // title: '制单员',
            title: Locale["Creator"],
            width: 150,
            dataIndex: 'createUser',
        }, {
            // title: '打印次数',
            title: Locale["Print Times"],
            width: 150,
            dataIndex: 'printingTimes',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 150,
            dataIndex: 'note',
        },  {
            // title: '应收金额',
            title: Locale["Receivable Amount"],
            width: 150,
            dataIndex: 'receivedAmount',
            fixed: "right"
        }
    ];
    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (record: ISaleSoDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: ISaleSoDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 550 }}
        />
    )
}
